<template>
    <span @click="sortListBy();" id="sort_button">
        <span class="title">{{sortName}}</span>
        <img v-show="imgShow == 0" src="@/assets/排序默认2.png" alt="">
        <img v-show="imgShow == 1"  src="@/assets/排序降2.png" alt="">
        <img v-show="imgShow == 2"  src="@/assets/排序升2.png" alt="">
    </span>
</template>

<script>
export default {
    name: 'LeeSortButton',
    props: {
        sortType: String,
        groupTag: String,
        sortName: String,
    },
    data() {
        return {
            flag: 0,
            imgShow: 0,
        }
    },
    watch: {
        groupTag(newVal) {
            if(newVal != this.sortType){
                this.flag = 0;
                this.imgShow = 0;
            }
        }
    },
    methods: {
        sortListBy() {
            this.flag++
            if(this.flag == 3){
                this.flag = 0;
            }
            this.imgShow = this.flag;
            switch (this.flag) {
                case 0:
                {
                    this.$emit('sort', {sort: this.sortType, sortMode:''})
                }
                    break;
                case 1:
                {
                    this.$emit('sort', {sort: this.sortType, sortMode:'desc'})
                }
                    break;
                case 2:
                {
                    this.$emit('sort', {sort: this.sortType, sortMode:'asc'})
                }
                    break;
                default:
                    break;
            }
        }
    }
}
</script>

<style lang='less'>
#sort_button {
    margin-right: 0;
    .title {
        vertical-align: middle;
        margin-right: 10px;
    }
    img {
        vertical-align: middle;
        width: 14px;
        height: 22px;
    }
}
</style>
